// src/components/templates/AuthLayout.js
import React from "react";
import TopAppBar from "../navigation/TopAppBar";
import { Box, Container } from "@mui/material";
import { TOP_APP_BAR_HEIGHT } from "../../constants/constants";

const AdminLayout = ({ children }) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      minHeight="100vh"
      sx={{ mb: "20px" }}
    >
      <TopAppBar />
      {/* Spacer to offset the fixed TopAppBar */}
      <Box sx={{ height: `${TOP_APP_BAR_HEIGHT}px` }} />
      <Container
        component="main"
        sx={{
          flexGrow: 1,
          px: { xs: 0, sm: 0 },
          py: { xs: 0, sm: 0 },
          mx: { xs: 0, sm: 0 },
          my: { xs: 0, sm: 0 },
          maxWidth: { xs: "100%", lg: "lg", xl: "xl" },
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default AdminLayout;
